import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { CatalogStatesResponse } from '@cp-mx/common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { fetchStateSelection } from './StateSlice';
import { StateContentSelector } from './StateContentSelector';

export function useStateSelection(): AbstractDataState<CatalogStatesResponse, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchStateSelection, StateContentSelector);
}
